<template>
  <div :class="isStickyHeader ? 'sticky-header-on' : 'sticky-header-off'">
    <Sticky v-model="isStickyHeader">
      <ul
        v-show="isStickyHeader"
        id="sticky-tabs"
        class="tabs hkld-tabs"
        data-tabs
      >
        <div>
          <div
            id="tabs-nav"
            class="tabs-title sticky-tabs-nav"
          >
            <a
              v-for="(tabName, index) in tabNames"
              :key="index"
              v-checkVisibility
              :class="{ 'is-active-tab': index === 0}"
              @mousedown="tabMousedownAction(index)"
              @click="navToTab(`#tab-${index}`, index, $event)"
            >
              <slot :name="`label-${index}`">
                {{ tabName }}
                <slot
                  :name="`icon-${index}`"
                />
              </slot>
            </a>
          </div>
          <div class="float-right">
            <slot name="float-right" />
          </div>
        </div>
      </ul>
    </Sticky>

    <div class="create-project-main">
      <ul
        id="common-tabs"
        class="row tabs hkld-tabs"
        data-tabs
        :style="extendStyleTabs"
      >
        <li
          v-for="(tabName, index) in tabNames"
          :key="index"
          class="tabs-title column"
          :class="{ 'is-active': index === 0}"
          :style="{overflow: showPopover(tabName)? 'visible' : 'hidden'}"
        >
          <a
            v-checkVisibility
            :href="`#tab-${index}`"
            :style="extendStyleA"
            @mousedown="tabMousedownAction(index)"
            @click="tabClickAction(index, $event)"
          >
            <slot :name="`label-${index}`">
              {{ tabName }}
              <slot
                :name="`icon-${index}`"
              />
            </slot>

            <Popover
              v-if="showPopover(tabName)"
              :width="300"
              :textAlign="'left'"
              :text="$t('standaloneWorkPermits.text')"
            />
          </a>
        </li>
      </ul>

      <div
        v-if="isMoreTabs"
        data-tabs-content="common-tabs"
        class="hkld-tabs-content"
      >
        <slot name="tabs" />
      </div>

      <div
        v-else
        data-tabs-content="common-tabs"
        class="hkld-tabs-content"
      >
        <div
          id="tab-0"
          class="tabs-panel is-active"
          :style="extendStyleContent"
        >
          <div class="clearfix">
            <slot name="tab-0" />
          </div>
        </div>
        <div
          id="tab-1"
          class="tabs-panel"
          :style="extendStyleContent"
        >
          <div class="clearfix">
            <slot name="tab-1" />
          </div>
        </div>
        <div
          id="tab-2"
          class="tabs-panel"
          :style="extendStyleContent"
        >
          <div class="clearfix">
            <slot name="tab-2" />
          </div>
        </div>
        <div
          id="tab-3"
          class="tabs-panel"
          :style="extendStyleContent"
        >
          <div class="clearfix">
            <slot name="tab-3" />
          </div>
        </div>
        <div
          id="tab-4"
          class="tabs-panel"
          :style="extendStyleContent"
        >
          <div class="clearfix">
            <slot name="tab-4" />
          </div>
        </div>
        <div
          id="tab-5"
          class="tabs-panel"
          :style="extendStyleContent"
        >
          <div class="clearfix">
            <slot name="tab-5" />
          </div>
        </div>
        <div
          id="tab-6"
          class="tabs-panel"
          :style="extendStyleContent"
        >
          <div class="clearfix">
            <slot name="tab-6" />
          </div>
        </div>
        <div
          id="tab-7"
          class="tabs-panel"
          :style="extendStyleContent"
        >
          <div class="clearfix">
            <slot name="tab-7" />
          </div>
        </div>
        <div
          id="tab-8"
          class="tabs-panel"
          :style="extendStyleContent"
        >
          <div class="clearfix">
            <slot name="tab-8" />
          </div>
        </div>
        <div
          id="tab-9"
          class="tabs-panel"
          :style="extendStyleContent"
        >
          <div class="clearfix">
            <slot name="tab-9" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
import Sticky from '@/controls/Sticky'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import { utils as formUtils } from '@/plugin/InputChange'
import Popover from '@/controls/Popover'

export default {
  name: 'TabsContainer',
  components: {
    Sticky,
    Popover,
  },
  props: {
    tabNames: {
      type: Array,
      required: true,
    },
    isMoreTabs: {
      type: Boolean,
      default: false,
    },
    getCurrentTab: {
      type: Function,
      default: () => {},
    },
    extendStyleTabs: {
      type: Object,
      default: () => {},
    },
    extendStyleA: {
      type: Object,
      default: () => {},
    },
    extendStyleContent: {
      type: Object,
      default: () => {},
    },
    /**
     * When true, tab clicks only emit `tabClick` — parent must call `selectTab` to change panes.
     * Use for leave-confirm flows so the destination tab is not shown under the modal.
     */
    manualTabSelect: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      isStickyHeader: false,
    }
  },
  mounted () {
    if (!this.commonTabs) {
      this.commonTabs = new Foundation.Tabs($('#common-tabs'))
    }

    // It must call the click function of <a>(tab title) in order to active tab content pane.
    const tabIndex1 = this.$router.currentRoute.query.tabIndex || 0
    $('#common-tabs li a')[tabIndex1].click()
    // TODO this tabIndex is same as query tabIndex. We should only keep one to avoid make logic too complicated and unreadable.
    const tabIndex = this.$router.currentRoute.params.tabIndex
    if (tabIndex) {
      this.selectTab(`#tab-${tabIndex}`, tabIndex)
    }

    const self = this
    EventBus.on('common-tabs-container-select-tab', (tabName, index, anchorId) => {
      const tabEl = tabName || `#tab-${index}`
      setTimeout(() => {
        self.selectTab(tabEl, index)
        if (anchorId) {
          setTimeout(() => {
            window.scrollTo(0, document.getElementById(anchorId).getBoundingClientRect().top)
          }, 100)
        }
      }, 100)
    })

    EventBus.on('common-tab-error-highlight', (tabIndices) => {
      this.updateTabErrorHighlight(tabIndices)
    })
  },
  destroyed () {
    EventBus.off('common-tabs-container-select-tab')
    EventBus.off('common-tab-error-highlight')
    if (this.commonTabs) {
      this.commonTabs.destroy()
    }
  },
  methods: {
    tabMousedownAction (index) {
      this.$emit('tabMousedown', index)
    },
    tabClickAction (index, event) {
      if (this.manualTabSelect && event) {
        event.preventDefault()
        event.stopPropagation()
        this.$emit('tabClick', index)
        return
      }
      this.refreshFusionInputCheck(index)
      this.autoResize()
      this.$emit('tabClick', index)
    },
    showPopover (tabName) {
      return tabName === this.$t('standaloneWorkPermits.name') && this.$parent.$options.name === 'TenancyView'
    },
    autoResize () {
      setTimeout(formUtils.resizeElements, 0)
    },
    selectTab (tabName, index) {
      $('#common-tabs').foundation('selectTab', tabName, false)
      $('#sticky-tabs #tabs-nav a').removeClass('is-active-tab')
      $('#sticky-tabs #tabs-nav a').eq(index).addClass('is-active-tab')
      if (this.getCurrentTab) {
        this.getCurrentTab(index)
      }
      // Wait for Foundation to hide the previous pane so leftover body-mounted
      // validation tips (e.g. Project Control) are dismissed when leaving that tab.
      setTimeout(() => {
        fusionInputCheckUtil.refreshFieldTips()
      }, 0)
    },
    navToTab (tabElem, index, event) {
      if (this.manualTabSelect && event) {
        event.preventDefault()
        event.stopPropagation()
        this.$emit('tabClick', index)
        return
      }
      this.refreshFusionInputCheck(index)
      $('#common-tabs').foundation('selectTab', tabElem, false)
      $(event.target).siblings().removeClass('is-active-tab')
      $(event.target).addClass('is-active-tab')
      this.autoResize()
      this.$emit('tabClick', index)
    },
    refreshFusionInputCheck (index) {
      this.getCurrentTab(index)
      setTimeout(() => {
        fusionInputCheckUtil.refreshFieldTips()
      }, 0)
      $('#tabs-nav').children().removeClass('is-active-tab')
      $('#tabs-nav a').eq(index).addClass('is-active-tab')
    },
    updateTabErrorHighlight (errorHighlightIndexs) {
      $(`#common-tabs a`).removeClass('error-highlight')
      errorHighlightIndexs.map(tabIndex => {
        $(`a#${tabIndex}-label`).addClass('error-highlight')
      })
    },
  },
}
</script>

/* Slotted batch-review links keep parent scope id; rules must be global (not scoped import). */
<style lang="scss">
#sticky-tabs .batch-review-nav__link {
  position: static !important;
  top: auto !important;
  right: auto !important;
  float: none !important;
  margin: 0;
  padding: 0 4px;
  font-style: normal;
  color: #0c3a58;
  cursor: pointer;
}

#sticky-tabs .batch-review-nav__link + .batch-review-nav__link {
  padding-left: 24px;
}

#sticky-tabs .batch-review-nav__link--disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: none;
}
</style>

<style lang="scss" scoped>
@import "~styles/tabsContainer";
.error-highlight {
  background-color: #f9dcda !important;
  background: #f9dcda !important;
}
.sticky-header-on ::v-deep .hide-while-sticky-header-on{
  display: none !important;
}
.sticky-header-off ::v-deep .show-only-while-sticky-header-on{
  display: none !important;
}

</style>
